export function getOptionsQty(options = []) {
    let qty = 0;
    options.forEach((option) => {
        if (option.children) {
            qty += getOptionsQty(option.children);
        }
        qty += 1;
    });
    return qty;
}
export function getAllOptionsValues(options = []) {
    const values = [];
    options.forEach((option) => {
        if (option.children) {
            values.push(...getAllOptionsValues(option.children));
        }
        values.push(option.value);
    });
    return values;
}
export function getFilteredOptions(options, searchValue) {
    if (!searchValue.trim())
        return options;
    const filteredOptions = [];
    const searchString = searchValue.toLowerCase();
    options.forEach((option) => {
        if (departmentOptionMatchSearch(option, searchString)) {
            filteredOptions.push(option);
        }
        else if (option.children) {
            const filteredChildren = getFilteredOptions(option.children, searchString);
            if (filteredChildren.length > 0) {
                filteredOptions.push({
                    ...option,
                    children: filteredChildren
                });
            }
        }
    });
    return filteredOptions;
}
function departmentOptionMatchSearch(option, searchString) {
    return option.label.toLowerCase().includes(searchString) || option.externalCode?.toLowerCase().includes(searchString);
}
export function findOptionByValue(data, value) {
    function iter(option) {
        if (option.value === value) {
            result = option;
            return true;
        }
        return Array.isArray(option.children) && option.children.some(iter);
    }
    let result;
    data.some(iter);
    return result;
}
export function getOptionAndChildrenIds(optionId, options) {
    const option = findOptionByValue(options, optionId.toString());
    if (!option)
        return [];
    const childrenIds = option.children ? getAllOptionsValues(option.children) : [];
    return [optionId, ...childrenIds];
}
export function excludeOptionAndChildrenIds(arr, optionId, options) {
    const optionAndChildrenIds = getOptionAndChildrenIds(optionId, options);
    return arr.filter((id) => !optionAndChildrenIds.includes(id));
}
